import { UserPageService } from './../user-page/user-page.service';
import { Component, OnInit, SimpleChanges, Input, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Employee } from 'src/app/data/models/employee.model';
import { UserRoleService } from 'src/app/services/user-role.service';
import { ToastrService } from 'ngx-toastr';
import * as Roles from '../../../../data/constants/roles';
import { NgForm } from '@angular/forms';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { UserService } from 'src/app/services/user.service';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: 'login-credentials',
  templateUrl: './login-credentials.component.html',
  styleUrls: ['./login-credentials.component.scss']
})
export class LoginCredentialsComponent implements OnInit, OnChanges, AfterViewInit {

  employee: any = new Employee({});
  employeeId;
  editmode = false;
  @Input() employeeCompany;
  @ViewChild('credSetForm', { static: false }) credSetForm: NgForm;
  pwd_hide: boolean = false;
  pwd_confirm_hide:  boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userRoleService: UserRoleService,
    private userService: UserService,
    private toastr: ToastrService,
    private userPageService: UserPageService
  ) {
    this.editmode = this.router.getCurrentNavigation()?.extras?.state ?
      (this.router.getCurrentNavigation().extras.state.editMode || false) : false;
  }

  ngOnInit() {
    const userInfo = JSON.parse(sessionStorage.getItem('user')); // IM-3125
    if (!userInfo || !userInfo.userName || userInfo.userName === '') {
      this.editmode = false;
    }
    this.employee.username = userInfo?.userName;
    this.employee.confirmPassword = '';
    this.employee.password = '';
  }

  ngAfterViewInit() {
    this.userPageService.statusChangeSubScriptionSubjectStep.subscribe((stepNumber: number) => {
      if (stepNumber === 3) {
        this.userPageService.formChangesSubscription = this.credSetForm.statusChanges.subscribe(() => {
          this.userPageService.formIsDirtySubject.next({
            dirty: this.credSetForm.dirty,
            formNumber: 3
          });
        });
      }
    });
  }

  loginCredentialsForm(credSetForm: NgForm) {

    if (credSetForm.invalid) {
      return false; // form state not valid , returnig here
    }
    if (this.employee.companyId && this.employeeId) {
      if (this.employee.password !== this.employee.confirmPassword) {
        CustomErrorToastComponent.showErrorToast(this.toastr, 'Password and confirm password are not matching');
        return false;
      }
      const payload = {
        password: this.employee.password,
        username: this.employee.username
      };
      if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
        this.saveCredentials(parseInt(sessionStorage.getItem('selectedCompanyId')), this.employeeId, payload);
      } else {
        this.saveCredentials(this.employee.companyId, this.employeeId, payload);
      }
    }
  }

  saveCredentials(companyId, employeeId, payload) {
    this.userRoleService.saveLoginCredentials(companyId, employeeId, payload).subscribe((response) => {
      if (response) {
        this.credSetForm.reset(this.credSetForm.value);
        this.toastr.success('Employee created successfully', 'Success');
        sessionStorage.removeItem('employeeId');
        if (this.userPageService.formChangesSubscription) {
          this.userPageService.formChangesSubscription.unsubscribe();
        }
        if(sessionStorage.getItem('userTypeRole')=='Attorney'){
          if(sessionStorage.getItem('selectedCompanyId')){
            this.router.navigate(['../users/'+sessionStorage.getItem('selectedCompanyId')], { relativeTo: this.route });
          } else {
            this.router.navigate(['../users'], { relativeTo: this.route });
          }
        } else {
          this.router.navigate(['../users'], { relativeTo: this.route });
        }
        
      }
    });
  }

  ngOnChanges(e: SimpleChanges) {
    if (e.employeeCompany && e.employeeCompany.currentValue) {
      this.employee.companyId = e.employeeCompany.currentValue.companyId;
      this.employeeId = e.employeeCompany.currentValue.employeeId;
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  // IM-3125
  changePassword() {
    const payload = {
      newpassword: this.employee.password,
      username: this.employee.username
    };
    this.userService.resetpassword(payload).subscribe((result: any) => {
      if (result.status === 200) {
        this.toastr.success('User password is modified', 'Success');
      }
    });
  }


}
